

























import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import type { Dictionary } from 'vue-router/types/router';
import { BaseIcon, IconSize } from '../base-icon';
import { BaseLink } from '../base-link';

export default defineComponent({
  name: 'BaseMenuItem',
  component: { BaseLink, BaseIcon },
  props: {
    label: {
      type: String,
      default: '',
    },
    to: {
      type: Object as PropType<{
        path: string;
        name: string;
        params?: Dictionary<string>;
        query?: Record<string, string>;
      }>,
      default: null,
    },
    dataExternal: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
    },
    hasChildren: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  setup(props) {
    const componentTag = computed(() => (props.disabled ? 'div' : 'BaseLink'));
    return { IconSize, componentTag };
  },
});
